import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchHitApplicationStatus } from '#/modules/search/components/Hit/SearchHitApplicationStatus';
import type { DatetimeString } from '#/types/TypedDateString';
import { timeago } from '#/utils/string/datetime/timeago';

import {
  SearchJobHitFooterContent,
  SearchJobHitFooterHolder,
  SearchJobHitFooterPublishedTimeago,
} from './SearchJobHitFooter.styled';

type Props = {
  application: {
    status: 'ACTIVE' | 'INACTIVE';
    created: DatetimeString;
  } | null;
  published: number | null;
  now: DatetimeString;
};

export function SearchJobHitFooter({ application, published, now }: Props) {
  const { i18n, locale } = useI18n();

  if (application)
    return (
      <SearchJobHitFooterHolder>
        <SearchJobHitFooterContent>
          <SearchHitApplicationStatus
            status={application.status}
            created={application.created}
          />
        </SearchJobHitFooterContent>
      </SearchJobHitFooterHolder>
    );

  if (!published) return;

  return (
    <SearchJobHitFooterHolder>
      <SearchJobHitFooterContent>
        {published && (
          <SearchJobHitFooterPublishedTimeago>
            {i18n('Posted %(postedAt)s', {
              postedAt: timeago(new Date(published * 1000).toISOString(), {
                locale,
                now,
              }),
            })}
          </SearchJobHitFooterPublishedTimeago>
        )}
      </SearchJobHitFooterContent>
    </SearchJobHitFooterHolder>
  );
}
